import { TextFormatType as g, TextAlignType as y } from "@nextgen-web-framework/all";
import { cmsColorOptionType as l } from "../../../components/TextOnly/types/enum.js";
import { ComponentType as u } from "../../registries/types/propTypes.js";
const a = (o) => {
  var i;
  const e = Array.isArray(o == null ? void 0 : o.text_only) ? o == null ? void 0 : o.text_only[0] : o == null ? void 0 : o.text_only, { display_title: t, color_options: c = { hex_code: "", select_color_options: "" } } = e, { hex_code: n, select_color_options: m } = c, r = m === l.HEXCODE, T = {
    text: t == null ? void 0 : t.text,
    formatType: (t == null ? void 0 : t.heading_type) ?? g.H2,
    alignment: (t == null ? void 0 : t.alignment) ?? y.CENTER,
    color: r ? n == null ? void 0 : n.title_color : ""
  }, f = {
    description: e == null ? void 0 : e.description,
    color: r ? n == null ? void 0 : n.description_color : ""
  };
  return {
    componentType: u.text_only,
    titleConfig: T,
    descriptionConfig: f,
    rounded: (e == null ? void 0 : e.rounded) ?? !0,
    bgColor: r ? n == null ? void 0 : n.text_background_color : "",
    theme: m === l.THEME ? (i = c == null ? void 0 : c.theme_color) == null ? void 0 : i.color : ""
  };
};
export {
  a as default
};
//# sourceMappingURL=text-only-transformer.js.map
